import type { AppShellLayout } from "@msuite/ui/app-shell";
import { LazyFallback } from "@msuite/ui/loading-screen";
import { SidebarNavigation, TopbarNavigation } from "@msuite/ui/navigation";
import React, { lazy, Suspense } from "react";
import { SuggestBetterTranslationModal } from "@/modals/localization";
import { useNavigationSetup } from "./use-navigation-setup";
import { CurrentAttendance } from "@/components/attendances";
import { useAuth } from "./use-auth";

const ProfileModal = lazy(() => import("@/modals/organizations/profile-modal"));

/** Props Interface */
interface NavigationWrapperProps {
	variant: AppShellLayout;
}

export function NavigationWrapper({ variant }: NavigationWrapperProps) {
	/** Hooks */
	const navigation = useNavigationSetup();
	const organization = useAuth().organization;

	/** Guard */
	if (!navigation.isSignedIn) return null;

	/** Render */
	return (
		<React.Fragment>
			{variant === "topbar" ? (
				<TopbarNavigation
					navigationItems={navigation.navigationItems}
					menuItems={() => navigation.menuItems}
				>
					<div className="card rounded-full py-1 pl-1.5">
						{organization.id && <CurrentAttendance />}
					</div>
				</TopbarNavigation>
			) : (
				<SidebarNavigation
					navigationItems={navigation.navigationItems}
					menuItems={() => navigation.menuItems}
				>
					<div className="border-t border-color py-2.5">
						{organization.id && <CurrentAttendance />}
					</div>
				</SidebarNavigation>
			)}
			<Suspense fallback={<LazyFallback variant="portal" />}>
				<SuggestBetterTranslationModal {...navigation.suggestTranslationModal} />
				{navigation.profileModal.isOpen && <ProfileModal {...navigation.profileModal} />}
			</Suspense>
		</React.Fragment>
	);
}
